import { useState, Fragment, useEffect } from 'react';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import { Button } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { IContact } from '../../common/model/mailchimp/contact.model';
import useI18n from '../../common/hooks/useI18n';

import { ModalForm } from '../shared';

type Props = {
  query: string;
  onButtonClick: (contact: IContact) => void;
  type?: 'primary' | 'default';
  size?: 'large' | 'middle';
  theme: DefaultTheme;
  className?: string;
};

const ContactButton = ({
  query,
  onButtonClick,
  type = 'primary',
  size,
  theme,
  className,
}: Props): JSX.Element => {
  const i18n = useI18n();
  const isSmd = useMediaQuery({ query: theme.breakpoints.smd });

  const [isMounted, setIsMounted] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);

  const computedSize = size || (isSmd ? 'middle' : 'large');

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <Fragment>
      {isMounted && (
        <Button
          className={className}
          htmlType="button"
          type={type}
          size={computedSize}
          onClick={() => {
            setModalVisible(true);
          }}
        >
          {i18n.t(`dynamic.sellHousePage.${query}.mainButton`)}
        </Button>
      )}
      <ModalForm
        isSellerMode={true}
        visible={isModalVisible}
        onOk={(contact) => {
          onButtonClick(contact);
          setModalVisible(false);
        }}
        onCancel={() => {
          setModalVisible(false);
        }}
      />
    </Fragment>
  );
};

export default withTheme<typeof ContactButton>(styled(ContactButton)`
  border-radius: 20px;

  &.ant-btn-default {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
  }
`);
